export type Bonus = {
  number: number;
  title: string;
  value: string;
  image: string;
  description: string[];
  listLabel?: string;
  items?: string[];
  flow?: string[];
  flowLabel?: string;
  closing: string[];
};

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: "50 Reflexology Practice Cards™",
    value: "$37",
    image: "https://cdn.magicpatterns.com/uploads/k1HfgjrRDm8c64LmBoh9aS/BONUS_1_REFLEXBLUEPRINT-EN.png",
    description: ["A collection of visual cards designed to help you review concepts, references, and small practice tasks."],
    listLabel: "Use them to",
    items: ["Review", "Study", "Practice", "Remember", "Self-test", "Create short review sessions"],
    closing: ["One card. One action. One small step forward."],
  },
  {
    number: 2,
    title: "The 15-Minute Practice Protocol™",
    value: "$37",
    image: "https://cdn.magicpatterns.com/uploads/b4RC51J4G5snY5qxmDhYhJ/BONUS_2_REFLEXBLUEPRINT-EN.png",
    description: ["I created this resource for anyone who wants an even more compact practice framework — a visual system designed to help you organize a basic practice session within a simple 15-minute structure."],
    flowLabel: "You'll follow",
    flow: ["Prepare", "Open", "Practice", "Close", "Record"],
    listLabel: "Includes",
    items: ["Timing guide", "Preparation", "Practice flow", "Closing", "Checklist"],
    closing: ["No jumping between five different resources. Just one simple structure to follow."],
  },
  {
    number: 3,
    title: "The Beginner Organization Mistakes Guide™",
    value: "$27",
    image: "https://cdn.magicpatterns.com/uploads/fscrXXRPcyrzfKyKU5unCz/BONUS_3_REFLEXBLUEPRINT-EN.png",
    description: ["The most common organization mistakes that can make reflexology study and practice much harder than they need to be."],
    listLabel: "Learn to identify issues related to",
    items: ["Organization", "Sequence", "References", "Preparation", "Study habits", "Documentation", "Consistency"],
    closing: ["Because sometimes progress isn't about learning more. It's about stopping the habits that waste your time."],
  },
  {
    number: 4,
    title: "The 21-Day Reflexology Practice Planner™",
    value: "$29",
    image: "https://cdn.magicpatterns.com/uploads/t5tZqfvAMJQHukHQv1EGCG/BONUS_4_REFLEXBLUEPRINT-EN.png",
    description: ["A simple 21-day framework designed to help you turn reflexology study and practice into a more consistent routine."],
    flowLabel: "Every day",
    flow: ["Learn", "Practice", "Record", "Review"],
    listLabel: "You'll also receive",
    items: ["Daily tracker", "Practice checklist", "Notes section", "Weekly review", "Progress tracker", "Final self-assessment"],
    closing: ["Small daily steps that add up to a real practice routine."],
  },
  {
    number: 5,
    title: "30 Reflexology Practice Checklists™",
    value: "$17",
    image: "https://cdn.magicpatterns.com/uploads/4SKK6fpfAwGvaQnUpegMWB/BONUS_5_REFLEXBLUEPRINT-EN.png",
    description: ["A collection of practical checklists covering different stages of your study and practice."],
    listLabel: "Including checklists for",
    items: ["Preparation", "Study", "Reference", "Practice", "Organization", "Materials", "Recording", "Review", "Follow-up", "Consistency"],
    closing: ["Print them. Save them on your phone. Keep them beside your practice materials."],
  },
];
